import { FC, useEffect, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core";

const DOTS_ANIMATION_INTERVAL = 350;

const useStyles = makeStyles(() =>
  createStyles({
    dot: {
      transition: "opacity 150ms",
    },
  }),
);

interface TypingIndicatorProps {
  dotCount?: number;
}

const TypingIndicator: FC<TypingIndicatorProps> = ({ dotCount = 3 }) => {
  const classes = useStyles();
  const [dotAnimationStep, setDotAnimationStep] = useState(0);

  useEffect(() => {
    const dotAnimationIntervalId = setInterval(() => {
      setDotAnimationStep(prev => (prev + 1) % dotCount);
    }, DOTS_ANIMATION_INTERVAL);

    return () => clearInterval(dotAnimationIntervalId);
  }, [dotCount]);

  return (
    <>
      {Array.from({ length: dotCount }).map((_, index) => (
        <span
          key={index}
          className={classes.dot}
          style={{ opacity: index === dotAnimationStep ? 1 : 0.3 }}
        >
          •
        </span>
      ))}
    </>
  );
};

export default TypingIndicator;
